import { motion } from "framer-motion";

/**
 * BackgroundDecor — fixed, full-site ambient decoration:
 *  - subtle dotted grid pattern
 *  - 3 floating violet glow orbs that drift slowly
 *  - top + bottom edge gradient fades for depth
 */
export default function BackgroundDecor() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
      data-testid="background-decor"
    >
      {/* Dotted grid */}
      <div
        className="absolute inset-0 opacity-[0.35]"
        style={{
          backgroundImage:
            "radial-gradient(rgba(255,255,255,0.06) 1px, transparent 1px)",
          backgroundSize: "32px 32px",
          maskImage:
            "radial-gradient(ellipse at center, black 40%, transparent 85%)",
          WebkitMaskImage:
            "radial-gradient(ellipse at center, black 40%, transparent 85%)",
        }}
      />

      {/* Violet orb — top left */}
      <motion.div
        className="absolute rounded-full blur-[120px]"
        style={{
          width: 540,
          height: 540,
          top: "-12%",
          left: "-8%",
          background:
            "radial-gradient(circle, rgba(183,148,246,0.22) 0%, rgba(183,148,246,0) 70%)",
        }}
        animate={{ x: [0, 60, -20, 0], y: [0, 40, -30, 0] }}
        transition={{ duration: 28, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* Violet orb — middle right */}
      <motion.div
        className="absolute rounded-full blur-[140px]"
        style={{
          width: 620,
          height: 620,
          top: "30%",
          right: "-12%",
          background:
            "radial-gradient(circle, rgba(196,168,255,0.18) 0%, rgba(196,168,255,0) 70%)",
        }}
        animate={{ x: [0, -50, 20, 0], y: [0, -40, 30, 0] }}
        transition={{ duration: 34, repeat: Infinity, ease: "easeInOut", delay: 4 }}
      />

      {/* Deep purple orb — bottom */}
      <motion.div
        className="absolute rounded-full blur-[160px]"
        style={{
          width: 720,
          height: 720,
          bottom: "-15%",
          left: "30%",
          background:
            "radial-gradient(circle, rgba(124,58,237,0.16) 0%, rgba(124,58,237,0) 70%)",
        }}
        animate={{ x: [0, 30, -40, 0], y: [0, -30, 20, 0] }}
        transition={{ duration: 40, repeat: Infinity, ease: "easeInOut", delay: 8 }}
      />

      {/* Top vignette */}
      <div
        className="absolute inset-x-0 top-0 h-40"
        style={{
          background:
            "linear-gradient(to bottom, rgba(5,5,5,1) 0%, rgba(5,5,5,0) 100%)",
        }}
      />
      {/* Bottom vignette */}
      <div
        className="absolute inset-x-0 bottom-0 h-48"
        style={{
          background:
            "linear-gradient(to top, rgba(5,5,5,1) 0%, rgba(5,5,5,0) 100%)",
        }}
      />
    </div>
  );
}
